import React from "react";
import { Modal } from "react-bootstrap";
import { FiX } from "react-icons/fi";

function BBQParty2022({ show, onClose, onOpen }) {
  // const [chatroomShow, setChatroomShow] = useState(false);
  // const handleChatroom = () => setChatroomShow(false);
  return (
    <div>
      <Modal
        size="xl"
        show={show}
        onHide={onClose}
        //  // backdrop="static"
        aria-labelledby="example-modal-sizes-title-lg"
        keyboard={false}
        animation={true}
        centered
      >
        <Modal.Body>
          <div>
            <div className="Solera__Cont">
              <FiX className="Solera__Close" onClick={onClose} />
            </div>{" "}
            <br /> <br />
            <div className="Exoc-Name">BBQ PARTY 2022</div>
            <br />
            <br />
            <div>
              <div className="container-fluid p-0">
                <div className="row g-4">
                  <div className="col-lg-4">
                    <div>
                      <img
                        src="/assets/Party2022/1.png"
                        alt=""
                        className="Photogallary2 "
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div>
                      <img
                        src="/assets/Party2022/2.png"
                        alt=""
                        className="Photogallary2 "
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div>
                      <img
                        src="/assets/Party2022/3.png"
                        alt=""
                        className="Photogallary2 "
                      />
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <div className="container-fluid p-0">
                <div className="row g-4">
                  <div className="col-lg-4">
                    <div>
                      <img
                        src="/assets/Party2022/4.png"
                        alt=""
                        className="Photogallary2 "
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div>
                      <img
                        src="/assets/Party2022/5.png"
                        alt=""
                        className="Photogallary2 "
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div>
                      <img
                        src="/assets/Party2022/6.png"
                        alt=""
                        className="Photogallary2 "
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default BBQParty2022;
